"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_from_layout_converter_1 = require("../base-from-layout.converter");
var idm_dynamic_layout_interpreter_1 = require("@synisys/idm-dynamic-layout-interpreter");
var immutable_1 = require("immutable");
var layout_utils_1 = require("../../../utils/layout-utils");
var page_converters_pool_1 = require("../../page-converters.pool");
var DomainCellFromPageCardConverter = /** @class */ (function (_super) {
    __extends(DomainCellFromPageCardConverter, _super);
    function DomainCellFromPageCardConverter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DomainCellFromPageCardConverter.prototype.apply = function (designerCardModel) {
        var styleMap = immutable_1.Map();
        styleMap.set('template', 'card');
        designerCardModel.height =
            designerCardModel.height < 158 ? 158 : designerCardModel.height;
        var cellProps = new idm_dynamic_layout_interpreter_1.CellPropertiesModel(designerCardModel.id, 'card', {
            xs: designerCardModel.columnCount,
            s: designerCardModel.columnCount,
            m: designerCardModel.columnCount,
        }, designerCardModel.height, styleMap);
        var rowId = layout_utils_1.LayoutUtils.uniqueId();
        designerCardModel.widgets.forEach(function (widget) {
            widget.height = designerCardModel.height;
        });
        var row = new idm_dynamic_layout_interpreter_1.RowModel(rowId, [
            page_converters_pool_1.PageConvertersPool.widgetCellFromLayout.apply(designerCardModel.widgets[0]),
        ], idm_dynamic_layout_interpreter_1.RowPropertiesModel.createEmpty(rowId));
        var gridId = layout_utils_1.LayoutUtils.uniqueId();
        var grid = new idm_dynamic_layout_interpreter_1.GridModel(gridId, [row], idm_dynamic_layout_interpreter_1.GridType.FLAT, idm_dynamic_layout_interpreter_1.GridPropertiesModel.createEmpty(gridId));
        return new idm_dynamic_layout_interpreter_1.CellModel(designerCardModel.id, cellProps, grid, undefined);
    };
    return DomainCellFromPageCardConverter;
}(base_from_layout_converter_1.BaseFromLayoutConverter));
exports.DomainCellFromPageCardConverter = DomainCellFromPageCardConverter;
//# sourceMappingURL=domain-cell-from-page-card.converter.js.map